function HamburgerIcon() {
    return (
        <>
            <span className="block h-0.5 w-8 animate-pulse bg-black"/>
            <span className="block h-0.5 w-8 animate-pulse bg-black"/>
            <span className="block h-0.5 w-8 animate-pulse bg-black"/>
        </>
    )
}

export default HamburgerIcon